export default __webpack_public_path__ + "static/media/Image-2.c99e247d.png";